import * as Flux from 'flux';

export interface DispatcherBaseAction {
    actionType: number;
    // tslint:disable-next-line:no-any
    value?: any;
}

class AppDispatcherClass extends Flux.Dispatcher<DispatcherBaseAction> {
}

export let AppDispatcher: AppDispatcherClass = new AppDispatcherClass();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/dispatcher/AppDispatcher.ts